import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/magento': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M445.7 127.9v256.1l-63.4 36.5v-255.8l-158.5-91.6-158.6 91.6 0.4 255.9-63.3-36.6v-255.9l221.9-128.1zM255.6 420.5v-255.9l63.4 36.6v256l-95.1 54.9-94.9-54.9-0.1-255.9 63.3-36.6v256l31.8 18.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/magento.js
// module id = 923
// module chunks = 0